import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";
const GENERIC_SUCCESS =
  "If an account with that email exists, a password reset link has been sent.";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return undefined;
    const timer = setInterval(() => {
      setCooldown((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.status === 429) {
        setCooldown(Number(data.retryAfterSeconds || 0));
        setError(data.error || "Too many password reset requests. Please try again later.");
        return;
      }
      if (!res.ok && res.status !== 400) {
        setError(data.error || "Service unavailable");
        return;
      }
      // For privacy, always show generic success regardless of whether account exists.
      setMessage(GENERIC_SUCCESS);
    } catch (err) {
      setError("Service unavailable");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Forgot password</h1>
        <form onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}
          {message && <div className="auth-success">{message}</div>}
          <div className="auth-field-last">
            <label className="auth-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              className="auth-input"
            />
          </div>
          <div className="edit-section">
            <button type="submit" disabled={submitting || cooldown > 0}>
              {submitting ? "Sending…" : cooldown > 0 ? `Try again in ${cooldown}s` : "Send reset link"}
            </button>
          </div>
        </form>
        <p className="auth-footer">
          <Link to="/login" className="auth-link">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
